export default __webpack_public_path__ + "static/hgr-logo-3df0aef26102ac4833887174deb269e2.png";